<div class="width-1100">

  <div class="upload-section">

    <input type="file" #fileImage (change)="onFileSelected($event)" accept="image/*, application/pdf"
      style="display:none;">
    <a mat-raised-button (click)='fileImage.click()' matTooltip='Selecionar arquivo'
      style='background-color: whitesmoke;'>
      <mat-icon class='icon-add'>image_search</mat-icon>
      Arquivo
    </a>

    <span style="margin: 0 20px 0 40px;" *ngIf="selectedFile">{{selectedFile.name}}</span>

    <a mat-raised-button style="margin: 0 0 0 20px;" (click)="startUpload()">
      {{ isUploading ? ' ...' : 'Upload' }}
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </a>

    <div *ngIf="uploadProgress | async as progress">
      <div class="progress-bar" [style.width.%]="progress">
        {{ progress | number:'1.0-0' }}%
      </div>
    </div>

    <p *ngIf="uploadError" class="error-message">
      Erro: {{ uploadError }}
    </p>

    <!--    <p *ngIf="downloadURL" class="success-message">
      Ok  <a [href]="downloadURL" target="_blank">{{ selectedFile?.name }}</a>
    </p>
-->

    <a mat-raised-button (click)='loadFiles()' matTooltip='Reload' style='background-color: whitesmoke;'>
      <mat-icon class='icon-done'>refresh</mat-icon>
    </a>

    <!--
    <a mat-raised-button (click)='listFiles()' matTooltip='Lista de arquivos' style='background-color: whitesmoke;'>
      <mat-icon class='icon-done'>content_copy</mat-icon>
    </a>
    -->

  </div>

  <!-- TABLE -->
  <mat-table style="height: calc(100vh - 300px); overflow: auto;" [dataSource]="dataSource" matSort
    matSortActive="period" matSortDirection='desc' matSortDisableClear=true>

    <!-- Image Column -->
    <ng-container matColumnDef="image">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Imagem </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div style="display: flex; flex-direction: column;">
          <div *ngIf='element.name.endsWith(".docx")'><img src="assets/images/geral/word_icon.png" [alt]="element.name"
              class="file-thumbnail"></div>
          <div *ngIf='element.name.endsWith(".pdf")'><img src="assets/images/geral/pdf_icon.png" [alt]="element.name"
              class="file-thumbnail"></div>
          <div *ngIf='!element.name.endsWith(".pdf") && !element.name.endsWith(".docx")'><img
              [src]="element.downloadURL" [alt]="element.name" class="file-thumbnail"> </div>

          <div> <a [href]="element.downloadURL" target="_blank">{{ element.name }}</a></div>
          <div>{{ element.timeCreated | date:'short' }}</div>
        </div>
      </mat-cell>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <a [href]="element.downloadURL" target="_blank">{{ element.name }}</a>
      </mat-cell>
    </ng-container>


    <!-- Date Column -->
    <ng-container matColumnDef="date">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Data </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.timeCreated | date:'short' }}
      </mat-cell>
    </ng-container>

    <!-- copy Column -->
    <ng-container matColumnDef="copy">
      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <a mat-button (click)='copyToClipboard(element)' style='background-color: whitesmoke;'>
          <mat-icon class='icon-done'>content_copy
          </mat-icon>
        </a>
      </mat-cell>
    </ng-container>

    <!-- delete Column -->
    <ng-container matColumnDef="delete">
      <mat-header-cell *matHeaderCellDef> </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <a mat-button (click)='openDelete(element)' style='background-color: whitesmoke;'>
          <mat-icon class='icon-delete'>delete_outline
          </mat-icon>
        </a>
      </mat-cell>
    </ng-container>

    <!-- Header -->
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

    <!-- Row -->
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

  </mat-table>
  <!-- END TABLE -->

</div>